import React, { useContext, useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import './style.css';
import { Stack } from '@mui/material';

export const WorkflowBreadCrumbs = observer(({ currentWorkflowId, workflowStatusByPipeLine }) => {
  return (
    <Stack direction={'row'}>
      <div className="sliderBtns leftArrow_btn">
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 43.791 40">
          <g transform="translate(-612.105 -562.956)">
            <g className="slederArrowBg" transform="translate(629.69 562.956)" fill="#fff">
              <path
                d="M 25.20557022094727 39 L -6.609937191009521 39 L -16.45893096923828 19.55655288696289 L -6.622636795043945 1 L 25.20557022094727 1 L 25.20557022094727 39 Z"
                stroke="none"
              />
              <path
                className="slederArrowStr"
                d="M -6.020910263061523 2 L -15.33267593383789 19.56699180603027 L -5.995505332946777 38 L 24.2055606842041 38 L 24.2055606842041 2 L -6.020910263061523 2 M -7.224369049072266 0 L 26.2055606842041 0 L 26.2055606842041 40 L -7.224369049072266 40 L -17.58520889282227 19.54611015319824 L -7.224369049072266 0 Z"
                stroke="none"
              />
            </g>
            <path
              className="slederBtnArrowBg"
              d="M-1989.845,8.135-1990,8l.018-.021-.018-.021.155-.136L-1983,0l1.5,1.317-5.829,6.662,5.829,6.662-1.5,1.318Z"
              transform="translate(2621.748 574.976)"
            />
          </g>
        </svg>
      </div>
      <div className="breadcrumb flat">
        {workflowStatusByPipeLine?.map((item) => {
          const customClassName = item.id.toString() === currentWorkflowId.toString() ? 'active' : '';
          return (
            <a key={item.id} className={customClassName}>
              {item.name}
            </a>
          );
        })}
      </div>
      <div className="sliderBtns rightArrow_btn">
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 43.791 40">
          <g transform="translate(-612.105 -562.956)">
            <g className="slederArrowBg" transform="translate(629.69 562.956)" fill="#fff">
              <path
                d="M 25.20557022094727 39 L -6.609937191009521 39 L -16.45893096923828 19.55655288696289 L -6.622636795043945 1 L 25.20557022094727 1 L 25.20557022094727 39 Z"
                stroke="none"
              />
              <path
                className="slederArrowStr"
                d="M -6.020910263061523 2 L -15.33267593383789 19.56699180603027 L -5.995505332946777 38 L 24.2055606842041 38 L 24.2055606842041 2 L -6.020910263061523 2 M -7.224369049072266 0 L 26.2055606842041 0 L 26.2055606842041 40 L -7.224369049072266 40 L -17.58520889282227 19.54611015319824 L -7.224369049072266 0 Z"
                stroke="none"
              />
            </g>
            <path
              className="slederBtnArrowBg"
              d="M-1989.845,8.135-1990,8l.018-.021-.018-.021.155-.136L-1983,0l1.5,1.317-5.829,6.662,5.829,6.662-1.5,1.318Z"
              transform="translate(2621.748 574.976)"
            />
          </g>
        </svg>
      </div>
    </Stack>
  );
});
